import React, {Component} from 'react';
import {UrlBuilder} from "../../../core/url/UrlBuilder";
import withStyles from '@mui/styles/withStyles';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import Slide from "@mui/material/Slide";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AppBar from "@mui/material/AppBar";
import Divider from "@mui/material/Divider";
import Checkbox from "@mui/material/Checkbox";
import AddIcon from '@mui/icons-material/Add';
import LinearProgress from "@mui/material/LinearProgress";
import Fade from "@mui/material/Fade";
import CircularProgress from "@mui/material/CircularProgress";
import ExerciseNewOrEditFormPopUp from "../../exercise/partials/ExerciseNewOrEditFormPopUp";
import {InputBase, ListItem, ListItemAvatar, ListItemText, Paper} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import {ColorPicker} from "../../../core/colors/ColorPicker";
import List from "@mui/material/List";
import SearchIcon from "@mui/icons-material/Search";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";

const useStyles = theme => ({
	button: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
		marginRight: theme.spacing(1)
	},
	appBar: {
		position: 'relative',
	},
	title: {
		marginLeft: theme.spacing(2),
		flex: 100,
	},
	grow: {
		flexGrow: 1,
	},
	root: {
		width: '100%',
	},
	small: {
		width: theme.spacing(4),
		height: theme.spacing(4),
	},
	searchBoxRoot: {
		padding: '2px 4px',
		display: 'flex',
		alignItems: 'center',
		width: '100%',
	},
	searchBoxInput: {
		marginLeft: theme.spacing(1),
		flex: 1,
	},
	iconButton: {
		padding: 10,
	},
	divider: {
		height: 28,
		margin: 4,
	},
});

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * Bloop to add new exercises to a routine.
 */
class RoutineExercisesEditFormBloop extends Component {
	/**
	 * @param props Containing:
	 *      'isOpen': Says whether this modal is open.
	 *      'closeSelfFunc': The function to call to close this popup.
	 */
	constructor(props) {
		super(props);

		this.state = {
			/**
			 * The routine to edit, if any. Otherwise the form will try to create one instead.
			 */
			routine: this.props.routine,
			/**
			 * 'isOpen': Says whether this bloop is open.
			 */
			isOpen: false,
			/**
			 * Used as a component 'is loading' indicator.
			 */
			isLoading: true,
			/**
			 * Is it currently being submitted?
			 */
			isSubmissionLoading: false,
			/**
			 * All the exercises that we have available for the user.
			 */
			fetchedExercises: [],
			/**
			 * The new exercises selected to be added to the routine from the list of fetchedExercises.
			 */
			selectedExercises: {},
			/**
			 * The exercises belonging to the routine
			 */
			routineExercises : this.props.routine ? this.props.routine.exercises : [],
			/**
			 * Show the add exercise popup
			 */
			showAddExercisePopUp: false,
			/**
			 * The search box text.
			 */
			searchBoxText: '',
		};
    }
    
    componentWillReceiveProps(nextProps, nextContext) {
	    if (this.state.isOpen !== Boolean(nextProps.isOpen)) {
		    this.setState({
			    isOpen: Boolean(nextProps.isOpen),
			    routine: nextProps.routine,
			    selectedExercises: {},
		    });
		    if (nextProps.isOpen) {
		        this.refresh(); // Only refresh when it was closed before and now its opening.
		    }
	    }
    }

    submitWithEnter = (e) => {
        if (e.key==='Enter') {
            this.submit(e);
        }
    }

	refresh = () => {
		this.fetchExercises();
	}
	
	fetchExercises = async () => {
		this.setState({
			isLoading: true
		});
		
		const exercisesResponse = await fetch(UrlBuilder.exercise.exercisesApi());
		let fetchedExercises = await exercisesResponse.json();

		// A new exercise was added because the list got bigger by 1, so let's pre-select it (kinda hacky) :)
		if (this.state.fetchedExercises && (fetchedExercises.length - 1 === this.state.fetchedExercises.length)) {
			let newSelectedExercises = this.state.selectedExercises;
			newSelectedExercises[fetchedExercises[fetchedExercises.length - 1].id] = true;
			
			this.setState({
				fetchedExercises: fetchedExercises,
				isLoading: false,
				selectedExercises: newSelectedExercises,
			});
			return;
		}

		this.setState({
			fetchedExercises: fetchedExercises,
			isLoading: false
		});
	}

	submit = async (event) => {
		event.preventDefault();
		
		this.setState({
			isSubmissionLoading: true,
		});

		let routineExercises = [];
		
		let sortNumber = this.state.routine && this.state.routine.exercises[this.state.routine.exercises.length - 1] ? 
			this.state.routine.exercises[this.state.routine.exercises.length - 1].sortNumber + 1 : 
			0; // If routine exists, take the biggest one which should be the last one in the list.
		
		for (let i = 0; i < this.state.fetchedExercises.length; i++) {
			let exercise = this.state.fetchedExercises[i];
			if (this.state.selectedExercises[exercise.id]) {
				routineExercises.push({
					id: exercise.id,
					sortNumber: sortNumber,
				});
				sortNumber++;
			}
		}

		let routineToSave = {
			id: this.state.routine.id,
			exercises: routineExercises,
		};
		
		await fetch(UrlBuilder.routine.routinesApi(), {
			method: 'PUT',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(routineToSave)
		})
			.then(response => response.json())
			.then(routine => this.props.closeSelfFunc(true));

		this.setState({
			selectedExercises: {}, // reset
			isSubmissionLoading: false,
		});
	}

	updateSearchBoxText = (value) => {
		this.setState({
			searchBoxText: value,
		});
	}
	
	getSearchedAvailableExercises = () => {
		let textToSearch = this.state.searchBoxText;

		if (this.state.searchBoxText.trim() === '') {
			return this.state.fetchedExercises;
		}

		textToSearch = textToSearch.toLowerCase();
		
		return this.state.fetchedExercises.filter(exercise =>
			exercise.name.toLowerCase().includes(textToSearch)
		);
	}
	
	updateStateCheckboxInputValues = (id) => {
		let newSelectedExercises = this.state.selectedExercises;
		newSelectedExercises[id] = !Boolean(newSelectedExercises[id]);
		
		this.setState({
			selectedExercises: newSelectedExercises
		});
	}

	toggleCloseAllPopups = (shouldRefresh = true) => {
		this.setState({
			showAddExercisePopUp: false,
		});
		if (shouldRefresh) {
			this.refresh();
		}
	}

	toggleOpenAddExercisePopup = () => {
		this.setState({
			showAddExercisePopUp: true
		});
	}

	isExerciseAlreadyInRoutine = (exerciseId) => {
		if (!this.state.routine || !this.state.routine.exercises) return false;
		return this.state.routine.exercises.some(re => re.exercise && re.exercise.id === exerciseId);
	}

	getSelectedCount = () => {
		return Object.values(this.state.selectedExercises).filter(v => v).length;
	}

	render() {
		const {classes} = this.props;

		let searchedAvailableExercises = this.getSearchedAvailableExercises();
		const selectedCount = this.getSelectedCount();

		return (
            <Dialog fullScreen open={this.state.isOpen} onClose={() => this.props.closeSelfFunc(false)} TransitionComponent={Transition}>
				<AppBar className={classes.appBar} enableColorOnDark>
					<Toolbar variant='dense'>
						<Typography variant="h6" noWrap className={classes.title}>
							Add Exercises
						</Typography>

						<div className={classes.grow}/>

						<IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => this.props.closeSelfFunc(false)}
                            size="large">
							<CloseIcon/>
						</IconButton>
					</Toolbar>
				</AppBar>

				<Fade in={this.state.isLoading}>
					<LinearProgress />
				</Fade>

				<DialogContent dividers sx={{ p: 0 }}>
					<Box sx={{ px: 2, pt: 2, pb: 1.5 }}>
						<Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>
							Select exercises from your library to add to this routine.
						</Typography>
						<Paper
							variant='outlined'
							component="form"
							sx={{
								display: 'flex',
								alignItems: 'center',
								borderRadius: 2,
								px: 1,
							}}
						>
							<IconButton size="small" sx={{ mr: 0.5 }}>
								<SearchIcon />
							</IconButton>

							<InputBase
								sx={{ flex: 1, fontSize: 14 }}
								placeholder="Search your exercises..."
								onChange={(e) => this.updateSearchBoxText(e.target.value)}
								value={this.state.searchBoxText}
							/>

							{this.state.searchBoxText ?
								<IconButton
									size="small"
									onClick={(e) => this.updateSearchBoxText('')}
								>
									<CloseIcon fontSize="small" />
								</IconButton> : null
							}
						</Paper>
					</Box>

					<Box sx={{ px: 2, pb: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<Typography variant="caption" sx={{ color: 'text.secondary' }}>
							{searchedAvailableExercises.length} exercise{searchedAvailableExercises.length !== 1 ? 's' : ''} in your library
						</Typography>
						<Button
							size="small"
							startIcon={<AddIcon />}
							onClick={this.toggleOpenAddExercisePopup}
							sx={{ textTransform: 'none', fontSize: 13 }}
						>
							Create new exercise
						</Button>
					</Box>

					<Divider />

					{searchedAvailableExercises.length === 0 ? (
						<Box sx={{ textAlign: 'center', py: 6, px: 3 }}>
							<FitnessCenterIcon sx={{ fontSize: 40, color: 'text.disabled', mb: 1.5 }} />
							<Typography variant="body2" sx={{ color: 'text.secondary', mb: 0.5 }}>
								{this.state.searchBoxText
									? `No exercises matching "${this.state.searchBoxText}"`
									: 'Your exercise library is empty'}
							</Typography>
							<Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 2 }}>
								Create an exercise first, then you can add it to this routine.
							</Typography>
							<Button
								variant="outlined"
								size="small"
								startIcon={<AddIcon />}
								onClick={this.toggleOpenAddExercisePopup}
								sx={{ textTransform: 'none' }}
							>
								{this.state.searchBoxText ? `Create "${this.state.searchBoxText}"` : 'Create an exercise'}
							</Button>
						</Box>
					) : (
						<List sx={{ px: 1 }}>
							{searchedAvailableExercises.map(exercise => {
								const alreadyInRoutine = this.isExerciseAlreadyInRoutine(exercise.id);
								const isSelected = Boolean(this.state.selectedExercises[exercise.id]);

								return (
									<ListItem
										key={exercise.id}
										button
										onClick={() => this.updateStateCheckboxInputValues(exercise.id)}
										sx={{
											borderRadius: 2,
											mb: 0.25,
											px: 1.5,
											bgcolor: isSelected
												? (theme) => theme.palette.mode === 'dark'
													? 'rgba(245,0,87,0.08)' : 'rgba(245,0,87,0.04)'
												: 'transparent',
										}}
									>
										<ListItemAvatar sx={{ minWidth: 40 }}>
											<Avatar
												sx={{
													width: 32,
													height: 32,
													fontSize: 14,
													fontWeight: 600,
													bgcolor: exercise.color ?? ColorPicker.pick(exercise.name),
												}}
											>
												{exercise.name.charAt(0).toUpperCase()}
											</Avatar>
										</ListItemAvatar>

										<ListItemText
											primary={
												<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
													<Typography variant="body2" sx={{ fontWeight: 500 }}>
														{exercise.name}
													</Typography>
													{alreadyInRoutine && (
														<Chip
															label="Added"
															size="small"
															icon={<CheckCircleIcon />}
															sx={{ height: 20, fontSize: 11, '& .MuiChip-icon': { fontSize: 14 } }}
														/>
													)}
												</Box>
											}
											secondary={
												<Typography variant="caption" sx={{ color: 'text.secondary' }}>
													{exercise.category ? exercise.category.name : 'No category'} &middot; {exercise.type.name}
												</Typography>
											}
										/>

										<Checkbox
											checked={isSelected}
											color='secondary'
											disableRipple
											size="small"
										/>
									</ListItem>
								);
							})}
						</List>
					)}
				</DialogContent>

				<DialogActions sx={{ px: 2, py: 1.5 }}>
					<Button
						variant="outlined"
						onClick={() => this.props.closeSelfFunc(false)}
						sx={{ textTransform: 'none' }}
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						color="secondary"
						onClick={this.submit}
						type="submit"
						value="Submit"
						disabled={this.state.isSubmissionLoading || this.state.isLoading || selectedCount === 0}
						sx={{ textTransform: 'none', fontWeight: 600, px: 3 }}
					>
						{this.state.isSubmissionLoading ?
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
								<CircularProgress size="1rem" color="inherit" /> Adding...
							</Box> :
							selectedCount > 0
								? `Add ${selectedCount} Exercise${selectedCount !== 1 ? 's' : ''}`
								: 'Select Exercises'
						}
					</Button>
				</DialogActions>

				<ExerciseNewOrEditFormPopUp
					isOpen={this.state.showAddExercisePopUp}
					name={this.state.searchBoxText.trim() !== '' ? this.state.searchBoxText : ''}
					closeSelfFunc={this.toggleCloseAllPopups}
				/>
			</Dialog>
        );
	}
}

export default withStyles(useStyles)(RoutineExercisesEditFormBloop);